import React from 'react';
import { EyeOffIcon, TagIcon } from 'lucide-react';
import { FieldDefinition, LoanRecord, LoanTag } from '../../types/highlights';
import { palette } from '../../utils/palette';
import { describeRule, isTagVisible } from '../../utils/rules';
interface LoanTagsRowProps {
  tags: LoanTag[];
  loan: LoanRecord;
  byId: Map<string, FieldDefinition>;
  isEditing: boolean;
  onManageTags: () => void;
}
export function LoanTagsRow({
  tags,
  loan,
  byId,
  isEditing,
  onManageTags
}: LoanTagsRowProps) {
  const visibleTags = tags.filter(tag => isTagVisible(tag, loan, byId));
  const hiddenTags = tags.filter(tag => !isTagVisible(tag, loan, byId));
  if (!isEditing && visibleTags.length === 0) return null;
  return <div role="group" aria-label="Loan tags" className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-b-md border-t border-[#e6ecf7] bg-[#f7f9fd] px-4 py-2.5" data-id="element-138" data-mp="111bhlzc3dcl1">
      <span className="flex shrink-0 items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-139" data-mp="2vgmbf0j76rnj">
        <TagIcon className="h-3 w-3" aria-hidden="true" data-id="element-140" data-mp="1p3ow5vwke3" />
        Loan tags
      </span>
      <span aria-hidden="true" className="h-4 w-px shrink-0 bg-slate-200" data-id="element-141" data-mp="3r89tydo47oa2" />
      <div className="flex flex-1 flex-wrap items-center gap-2" data-id="element-142" data-mp="9tcr8lzblhaa">
      {visibleTags.length === 0 && hiddenTags.length === 0 ? <span className="text-[12px] text-slate-400" data-id="element-143" data-mp="4v1heb90z6s2">No tags configured</span> : null}
      {visibleTags.map(tag => <span key={tag.id} title={tag.description ?? tag.label} className={['inline-flex h-8 items-center rounded-md border px-3 text-[13px] font-semibold', palette[tag.color].chip, palette[tag.color].text].join(' ')} data-id="element-144" data-mp="3dbmiz6zbuxl5">
          {tag.label}
        </span>)}

      {isEditing ? hiddenTags.map(tag => <span key={tag.id} title={!tag.enabled ? 'Turned off' : `Hidden on this loan — shows when ${describeRule(tag.condition, byId)}`} className="inline-flex h-8 items-center gap-1.5 rounded-md border border-dashed border-slate-300 bg-white px-3 text-[13px] font-medium text-slate-400" data-id="element-145" data-mp="12jbmx080scnx">
              <EyeOffIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-146" data-mp="1jil5ipah0hgl" />
              {tag.label}
            </span>) : null}

      {isEditing ? <button type="button" onClick={onManageTags} className="inline-flex h-8 items-center gap-1.5 rounded-md border border-[#cfe0f5] bg-white px-3 text-[13px] font-semibold text-[#0b5cab] transition hover:bg-[#f3f8ff] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0b5cab]" data-id="element-147" data-mp="lwxiuw3thdi9">
          <TagIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-148" data-mp="34mojqn8anvr" />
          Manage tags
        </button> : null}
      </div>
    </div>;
}